module.exports = __webpack_public_path__ + "img/enabled.1886871c.svg";